import {useEventListener} from '@vueuse/core'
import {useRouter} from 'vue-router'
import {useCurrentAppPlatform} from '@toolify/client/src/modules/platform/composables/useCurrentAppPlatform'
import {AppPlatformType} from '@toolify/server/src/models/mongoose/SessionModel/enum/AppPlatformType'
import {getInternalHrefPath} from '@toolify/client/src/modules/routes/functions/getInternalHrefPath'
import {getInternalLinkHosts} from '@toolify/client/src/modules/internalLinks/functions/getInternalLinkHosts'
import {useOpenAiResource} from '@toolify/client/src/modules/chat/composables/useOpenAiResource'
import {AI_RESOURCE_LINK_CLASS_NAME} from '@toolify/client/src/modules/chat/constants/aiResourceLinkClassName'

export function useInternalLinkInterception(): void {
  const router = useRouter()
  const {currentAppPlatformType} = useCurrentAppPlatform()
  const {openAiResource} = useOpenAiResource()

  function onDocumentClick(event: MouseEvent): void {
    if (currentAppPlatformType !== AppPlatformType.Mobile) {
      return
    }
    // This listener runs in the capture phase, so anything it swallows never reaches the element's
    // own handler. Respect a decision something upstream already made.
    if (event.defaultPrevented) {
      return
    }
    const target = event.target as HTMLElement | null
    const anchor = target?.closest?.('a')
    const href = anchor?.getAttribute('href')
    if (!href) {
      return
    }
    const path = getInternalHrefPath(href, {
      baseHref: window.location.href,
      currentHost: window.location.host,
      internalHosts: getInternalLinkHosts(),
    })
    if (!path) {
      return
    }
    event.preventDefault()
    if (anchor.classList.contains(AI_RESOURCE_LINK_CLASS_NAME)) {
      void openAiResource(path)
      return
    }
    void router.push(path)
  }

  useEventListener(document, 'click', onDocumentClick, {capture: true})
}
